export default __webpack_public_path__ + "static/media/lamp5.aa76acac.webp";